<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">后台管理系统</div>
      <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
        <el-form-item prop="username">
          <el-input v-model="param.username" placeholder="username">
            <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" placeholder="password" v-model="param.password" @keyup.enter.native="submitForm()">
            <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
          </el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="submitForm()">登录</el-button>
        </div>
        <p class="login-tips"></p>
      </el-form>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import CryptoJS from '../../../utils/CryptoJS.js'
  export default {
    data: function() {
      return {
        param: {
          username: '',
          password: '',
        },
        rules: {
          username: [{
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }],
        },
      };
    },
    methods: {
      submitForm() {
        const self = this
        let loginName = CryptoJS.encrypt(self.param.username)
        let userpassword = CryptoJS.encrypt(self.param.password)
        self.$refs.login.validate((valid) => {
          if (valid) {
            // self.globalMethod.showLoading('登录中')
            self.axios.post('api/admin/user/login', {
              loginName: loginName,
              password: userpassword
            }).then((data) => {
              if (data.success) {
                // 登录的时候保存用户信息  和 token
                self.globalMethod.setUserInfo(JSON.stringify(data.entity))
                localStorage.setItem('userMessage', JSON.stringify(data.entity))
                localStorage.setItem('token', data.entity.token)
                localStorage.setItem('path', '/')
                console.log(localStorage.getItem("token"))
                Cookies.set('isLogin', true, 60)
                Cookies.set('userId', true, 60)
                let isLogin = Cookies.get('userId')
                console.log(isLogin)
                console.log( localStorage.getItem('user_info'))
                self.showList = false
                self.globalMethod.destroyShow()
                self.globalMethod.showSuccess('登录成功')
                self.$router.push({
                  path: '/user_wx'
                })
              } else {
                console.log(data.msg)
                self.globalMethod.showError(data.msg)
                self.globalMethod.destroyShow()
              }
            })
          } else {
            this.$message.error('请输入账号和密码');
            console.log('error submit!!');
            return false;
          }
        })

        // this.$refs.login.validate(valid => {
        //     if (valid) {
        //         this.$message.success('登录成功');
        //         localStorage.setItem('ms_username', this.param.username);
        //         this.$router.push('/');
        //     } else {
        //         this.$message.error('请输入账号和密码');
        //         console.log('error submit!!');
        //         return false;
        //     }
        // });
      },
    },
  };
</script>

<style scoped>
  .login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/login-bg.jpg);
    background-size: 100%;
  }

  .ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
  }

  .ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
  }

  .ms-content {
    padding: 30px 30px;
  }

  .login-btn {
    text-align: center;
  }

  .login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
  }

  .login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/Login.vue